<div class="row">
    <div class="col-sm-10">
        <div class="row no-gutters">
            <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.tax_deduction + '.')"
                                [inputLabel]="case.trans.tax_deduction | translate"
                                [trueFalseNull]="case.tax_deduction"
                                (trueFalseNullChange)="onChange('tax_deduction', $event)"
                                class="full-width">
            </app-boolean-toggle>
        </div>
    </div>
    <div class="col-sm-2">
      <!-- PLACEHOLDER FOR ACTION BUTTONS-->
    </div>
</div>

<div class="row">
    <div class="col-sm-10">
        <div class="row no-gutters">
            <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.vehicle_towed + '.')"
                                [inputLabel]="case.trans.vehicle_towed | translate"
                                [trueFalseNull]="case.vehicle_towed"
                                (trueFalseNullChange)="onChange('vehicle_towed', $event)"
                                class="full-width">
            </app-boolean-toggle>
        </div>
    </div>
    <div class="col-sm-2">
      <!-- PLACEHOLDER FOR ACTION BUTTONS-->
    </div>
</div>

<div class="row">
    <div class="col-sm-10">
        <div class="row no-gutters">
            <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.rental_car_needed + '.')"
                                [inputLabel]="case.trans.rental_car_needed | translate"
                                [trueFalseNull]="case.rental_car_needed"
                                (trueFalseNullChange)="onChange('rental_car_needed', $event)"
                                class="full-width">
            </app-boolean-toggle>
        </div>
    </div>
    <div class="col-sm-2">
      <!-- PLACEHOLDER FOR ACTION BUTTONS-->
    </div>
</div>

<div class="row">
    <div class="col-sm-10">
        <div class="row no-gutters">
            <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.vehicle_financed + '.')"
                                [inputLabel]="case.trans.vehicle_financed | translate"
                                [trueFalseNull]="case.vehicle_financed"
                                (trueFalseNullChange)="onChange('vehicle_financed', $event)"
                                class="full-width">
            </app-boolean-toggle>
        </div>
    </div>
    <div class="col-sm-2">
      <!-- PLACEHOLDER FOR ACTION BUTTONS-->
    </div>
</div>

<div class="row">
    <div class="col-sm-10">
        <div class="row no-gutters">
            <app-boolean-toggle [idPrefix]="(idPrefix + case.trans.vehicle_leased + '.')"
                                [inputLabel]="case.trans.vehicle_leased | translate"
                                [trueFalseNull]="case.vehicle_leased"
                                (trueFalseNullChange)="onChange('vehicle_leased', $event)"
                                class="full-width">
            </app-boolean-toggle>
        </div>
    </div>
    <div class="col-sm-2">
      <!-- PLACEHOLDER FOR ACTION BUTTONS-->
    </div>
</div>
